module.exports = __webpack_public_path__ + "static/media/9_1.7b873860.png";